module.exports = __webpack_public_path__ + "static/img/xsje.91fb759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/xsje.png
// module id = /ige
// module chunks = 1